export default __webpack_public_path__ + "static/media/ArrowRightSwitch.83ddafab.svg";